import { useCallback } from 'react';
import { useAuth } from 'react-oidc-context';

import { useEventDispatcher } from '../../eventing/components/eventing-service-provider/eventing-service-provider';
import { EventName } from '../../eventing/interfaces/events.interface';

import { useFullLocation } from './use-full-location';

export function useSignIn() {
    const auth = useAuth();
    const fullLocation = useFullLocation();
    const dispatchEvent = useEventDispatcher();

    return useCallback(
        (params?: { acrValues?: string; returnQueryParameters?: Record<string, string> }) => {
            const url = new URL(fullLocation);
            const newParams = new URLSearchParams(url.search);

            if (params?.returnQueryParameters) {
                Object.entries(params.returnQueryParameters).forEach(([key, value]) => {
                    newParams.set(key, value);
                });
            }

            if (dispatchEvent({ name: EventName.LOGIN_REQUEST })) {
                return;
            }

            url.search = newParams.toString();
            const isPopup = !!params?.acrValues;
            const signupFunction = isPopup ? auth.signinPopup : auth.signinRedirect;

            return signupFunction.bind(auth)({
                redirect_uri: url.toString(),
                ...(params?.acrValues
                    ? {
                          extraQueryParams: { acr_values: params.acrValues },
                      }
                    : {}),
            });
        },
        [auth, dispatchEvent, fullLocation],
    );
}
